// ─── Metric Cards ─────────────────────────────────────────────────────────────

export const METRIC_CARDS = [
  {
    label: "Media spend",
    sub: "Total marketing spend",
    metric: "Cost",
    value: "$56,692",
  },
  {
    label: "Impressions",
    sub: "Total number of impressions",
    metric: "Impressions",
    value: "835,297",
  },
  {
    label: "Clicks",
    sub: "Clicks for the entire campaign",
    metric: "Clicks",
    value: "27,449",
  },
  {
    label: "Leads",
    sub: "Total number of leads",
    metric: "Leads",
    value: "1,330",
  },
];

// ─── Impressions by State ─────────────────────────────────────────────────────

export const STATE_TOTAL_LABEL = "835,297K";

export const STATE_TOOLTIP = { label: "Illinois", value: "11,259" };

export const STATE_DATA = [
  { state: "California", value: 403849, pct: 100 },
  { state: "New York", value: 279323, pct: 69 },
  { state: "Texas", value: 85933, pct: 21 },
  { state: "Florida", value: 54933, pct: 14 },
  { state: "Illinois", value: 11259, pct: 3 },
];

// ─── Overview ─────────────────────────────────────────────────────────────────

export const OVERVIEW_STATS = [
  { label: "Users", value: "8.8k", change: "7.4%", up: true },
  { label: "Sessions", value: "10.2k", change: "7.2%", up: true },
  { label: "Bounce rate", value: "46.2%", change: "0.2%", up: false },
  { label: "Session duration", value: "4m 24s", change: "10.8%", up: true },
];

export const OVERVIEW_LINE_DATA = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  datasets: [
    {
      label: "Sessions",
      data: [
        3200, 4100, 3800, 5200, 6100, 5700, 7100, 6800, 5900, 6400, 5500, 4800,
      ],
      borderColor: "#7F56D9",
      backgroundColor: "rgba(127,86,217,0.08)",
      tension: 0.4,
      fill: true,
      pointRadius: 0,
      borderWidth: 2,
    },
    {
      label: "Engaged Sessions",
      data: [
        1800, 2600, 2200, 3300, 3800, 3400, 4500, 4200, 3700, 4100, 3600, 3100,
      ],
      borderColor: "#9E77ED",
      backgroundColor: "rgba(158,119,237,0.04)",
      tension: 0.4,
      fill: false,
      pointRadius: 0,
      borderWidth: 2,
    },
  ],
};

// ─── Impressions by Device ────────────────────────────────────────────────────

export const IMPRESSIONS_DEVICE_DATA = {
  total: "835,297",
  devices: [
    { label: "Mobile", value: 476119, color: "#7F56D9" },
    { label: "Desktop", value: 359177, color: "#EE46BC" },
  ],
};

// ─── Channel Breakdown ────────────────────────────────────────────────────────

export const CHANNEL_LEADS_DATA = {
  labels: ["Search", "Online Media", "Paid Media", "Owned Media"],
  values: [725, 291, 276, 38],
  pcts: ["72.5 (78%)", "29.1 (31%)", "27.6 (30%)", "3.81 (4%)"],
  colors: ["#7F56D9", "#9E77ED", "#C4B5FD", "#EDE9FE"],
};

export const CHANNEL_IMPRESSIONS_DATA = {
  labels: ["Search Media", "Paid Media", "Online Media", "Owned Media"],
  values: [524, 434, 264, 991],
  pcts: ["52.4 (56%)", "43.4 (46%)", "26.4 (28%)", "99.1 (100%)"],
  colors: ["#7F56D9", "#9E77ED", "#C4B5FD", "#533291"],
};

export const CHANNEL_ENROLLMENTS_DATA = {
  labels: ["Search", "Online Media", "Paid Media", "Owned Media"],
  values: [52, 40, 13, 9],
  pcts: ["52 (25%)", "40 (19%)", "13 (6%)", "9 (4%)"],
  colors: ["#7F56D9", "#9E77ED", "#C4B5FD", "#EDE9FE"],
};

export const CHANNEL_APPLICATIONS_DATA = {
  labels: ["Search", "Online Media", "Paid Media", "Owned Media"],
  values: [86, 41, 29, 2],
  pcts: ["86 (59%)", "41 (28%)", "29 (20%)", "2 (1%)"],
  colors: ["#7F56D9", "#9E77ED", "#C4B5FD", "#EDE9FE"],
};

// ─── Sessions by Country ──────────────────────────────────────────────────────

export const SESSIONS_TOTAL = 981;

export const SESSIONS_COUNTRY_DATA = {
  labels: ["US", "CA", "Aus"],
  datasets: [
    {
      data: [60, 25, 15],
      backgroundColor: ["#7F56D9", "#C4B5FD", "#EDE9FE"],
      borderWidth: 0,
      hoverOffset: 4,
    },
  ],
};

// ─── Acquire Users ────────────────────────────────────────────────────────────

export const ACQUIRE_CATEGORY_TABS = ["Traffic channel", "Source", "Referrals"];
export const ACQUIRE_TABS = ["12 months", "30 days", "7 days"];

export const ACQUIRE_USERS_DATA = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  datasets: [
    {
      label: "Social Media",
      data: [380, 420, 390, 510, 580, 540, 620, 600, 530, 570, 490, 450],
      backgroundColor: "#7F56D9",
      borderRadius: 0,
      barPercentage: 0.55,
      categoryPercentage: 0.7,
    },
    {
      label: "Search",
      data: [290, 310, 280, 370, 420, 390, 460, 440, 380, 410, 350, 320],
      backgroundColor: "#9E77ED",
      borderRadius: 0,
      barPercentage: 0.55,
      categoryPercentage: 0.7,
    },
    {
      label: "Paid Media",
      data: [180, 210, 195, 240, 280, 260, 300, 290, 250, 270, 230, 200],
      backgroundColor: "#C4B5FD",
      borderRadius: 4,
      barPercentage: 0.55,
      categoryPercentage: 0.7,
    },
  ],
};

// ─── Traffic Sources ──────────────────────────────────────────────────────────

export const TRAFFIC_RADAR_DATA = {
  labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  datasets: [
    {
      label: "Direct",
      data: [72, 88, 60, 75, 55, 68, 80],
      backgroundColor: "rgba(127,86,217,0.35)",
      borderColor: "#7F56D9",
      pointBackgroundColor: "#7F56D9",
      pointRadius: 3,
      borderWidth: 2,
    },
    {
      label: "Social",
      data: [55, 70, 85, 50, 90, 60, 45],
      backgroundColor: "rgba(238,70,188,0.25)",
      borderColor: "#EE46BC",
      pointBackgroundColor: "#EE46BC",
      pointRadius: 3,
      borderWidth: 2,
    },
    {
      label: "Referral",
      data: [40, 55, 45, 90, 65, 80, 60],
      backgroundColor: "rgba(6,174,212,0.25)",
      borderColor: "#06AED4",
      pointBackgroundColor: "#06AED4",
      pointRadius: 3,
      borderWidth: 2,
    },
  ],
};

// ─── Top Performing Campaigns ─────────────────────────────────────────────────

export const CAMPAIGNS_COLUMNS = [
  { key: "name", label: "Campaign" },
  { key: "impressions", label: "Impressions" },
  { key: "clicks", label: "Clicks" },
  { key: "ctr", label: "CTR" },
  { key: "spend", label: "Spend/Cost" },
];

export const TOP_CAMPAIGNS = [
  {
    name: "Facebook Ads Master in Biotechnology",
    impressions: "1,955",
    clicks: 276,
    ctr: "43%",
    spend: "$296.57",
  },
  {
    name: "Facebook Ads Ph.D. Master's in Computer Science",
    impressions: "2,940",
    clicks: 164,
    ctr: "34.52%",
    spend: "$253.4k",
  },
  {
    name: "Twitter (X) Dallas Bachelor in Chemistry",
    impressions: "6,040",
    clicks: 152,
    ctr: "1000000%",
    spend: "$688.75",
  },
];

// ─── Profile Performance ──────────────────────────────────────────────────────

export const PROFILE_PERFORMANCE_DATA = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  datasets: [
    {
      label: "Reach",
      data: [400, 480, 320, 560, 610, 520, 700, 680, 590, 640, 550, 480],
      backgroundColor: "#7F56D9",
      borderRadius: 3,
      barPercentage: 0.7,
      stack: "engagement",
    },
    {
      label: "Followers",
      data: [200, 240, 160, 280, 305, 260, 350, 340, 295, 320, 275, 240],
      backgroundColor: "#9E77ED",
      borderRadius: 3,
      barPercentage: 0.7,
      stack: "engagement",
    },
    {
      label: "Visitors",
      data: [120, 145, 95, 168, 183, 156, 210, 204, 177, 192, 165, 144],
      backgroundColor: "#C4B5FD",
      borderRadius: 3,
      barPercentage: 0.7,
      stack: "engagement",
    },
  ],
};

// ─── Social Media – Facebook ──────────────────────────────────────────────────

export const SOCIAL_FB_TABS = ["9 months", "20 days", "7 days"];

export const SOCIAL_FB_COLUMNS = [
  { key: "program", label: "Program", align: "left" },
  { key: "impressions", label: "Total Impressions", align: "right" },
];

export const SOCIAL_FB_DATA = [
  { program: "Online Master of Informatics", impressions: 553 },
  { program: "Master's in Geographic Information Systems", impressions: 761 },
  { program: "Online Bachelor's in Physics", impressions: 553 },
  { program: "Master Liu's Biotechnology", impressions: 553 },
  { program: "Bachelor's in Astronomical Sciences", impressions: 553 },
  { program: "Online Bachelor's in Chemistry", impressions: 553 },
];
